import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import ConversationItemCard from 'components/lib/customer_conversation_card/conversation_item_card';
import CustomerCard from 'components/lib/customer_conversation_card/customer_card';
import Link from 'components/common/link';

export default function CustomerConversationItemCard(props) {
  const classNames = classnames('customerConversationItemCard', {
    'customerConversationItemCard-selected': props.isSelected,
  });
  const { profile, onClick, conversationItem } = props;
  const content = (
    <div className={classNames} onClick={onClick}>
      <CustomerCard {...profile} />
      <ConversationItemCard {...conversationItem} />
    </div>
  );

  if (props.isLink) {
    let linkUrl = props.itemId
      ? `/customer/${profile.id}/item/${props.itemId}`
      : `/customer/${profile.id}/conversation/${props.conversationId}`;

    return (
      <div>
        <Link className="unstyled" href={linkUrl} onClick={noop => {}}>
          {content}
        </Link>
      </div>
    );
  }

  return content;
}

CustomerConversationItemCard.propTypes = Object.assign({
  conversationId: PropTypes.string,
  conversationItem: PropTypes.object,
  isLink: PropTypes.bool,
  isSelected: PropTypes.bool,
  itemId: PropTypes.string,
  onClick: PropTypes.func,
  profile: PropTypes.shape(CustomerCard.propTypes),
});
